/** Single source of truth for the dashboard URLs, shared by the router and the sidebar. */
export const dashboardRoutes = {
  overview: "/dashboard",
  bookings: "/dashboard/bookings",
  bookingNew: "/dashboard/bookings/new",
  bookingEdit: "/dashboard/bookings/edit/:id",
  drivers: "/dashboard/drivers",
  driverNew: "/dashboard/drivers/new",
  driverEdit: "/dashboard/drivers/edit/:id",
  customers: "/dashboard/customers",
  services: "/dashboard/services",
  payments: "/dashboard/payments",
  enquiry: "/dashboard/enquiry",
  enquiries: "/dashboard/enquiry",
  profile: "/dashboard/profile",
  notifications: "/dashboard/notifications",
  vehicleCategoriesBrands: "/dashboard/services/vehicle-categories-brands",
  fleetNew: "/dashboard/services/fleet/new",
  fleetEdit: "/dashboard/services/fleet/:id",
  serviceNew: "/dashboard/services/:category/new",
  serviceEdit: "/dashboard/services/edit/:id",
} as const;

export type DashboardRoute =
  (typeof dashboardRoutes)[keyof typeof dashboardRoutes];
